<template>
  <header :class="$style.header">
    <CountrySearch
      v-model:searchQuery="searchQuery"
      :suggestions="suggestions"
    />
    <AppSelect
      :options="availableRegions"
      :selected-option="selectedRegionPlaceholder"
      :active-descendant="activeDescendant"
      @optionChange="changeSelectedRegion"
    />
  </header>
</template>

<script>
import { computed, watch } from 'vue';
import useSelectRegion from '@/composables/useSelectRegion';
import useSearch from '@/composables/useSearch';

import CountrySearch from '@/components/AppCountrySearch.vue';
import BaseSelect from '@/components/BaseSelect.vue';

const regions = [
  { name: 'Africa', id: 1, value: 'africa' },
  { name: 'America', id: 2, value: 'americas' },
  { name: 'Asia', id: 3, value: 'asia' },
  { name: 'Europe', id: 4, value: 'europe' },
  { name: 'Ocenia', id: 5, value: 'oceania' },
];

export default {
  components: {
    CountrySearch,
    AppSelect: BaseSelect,
  },
  emits: ['selectedRegionUpdate'],
  setup(_, { emit }) {
    const {
      availableRegions,
      selectedRegion,
      changeSelectedRegion,
    } = useSelectRegion(regions);

    const selectedRegionPlaceholder = computed(() => (selectedRegion.value ? selectedRegion.value.name : 'Filter by Region'));
    const activeDescendant = computed(() => (selectedRegion.value ? selectedRegion.value.value : ''));
    watch(selectedRegion, (newValue) => emit('selectedRegionUpdate', newValue));

    const { searchQuery, suggestions } = useSearch('https://restcountries.eu/rest/v2/name/');

    return {
      availableRegions,
      selectedRegion,
      activeDescendant,
      changeSelectedRegion,
      selectedRegionPlaceholder,
      searchQuery,
      suggestions,
    };
  },
};
</script>

<style lang="scss" module>
@import '@/assets/scss/_shared';

.header {
  margin-top: clamp(1.5rem, 5vw, 3rem);

  @include screenMedium {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > *:nth-child(even) {
      margin-left: 1.5rem;
    }
  }
}
</style>
